module.exports = __webpack_public_path__ + "static/media/image-me.9aaa2af5.jpg";